import createStore from './create';

const store = createStore();

export default store;
